import { useLayoutEffect, useState } from 'react';

import { ThemeType } from '@infoods/lifebase-ui';

import { getService } from 'react-in-angularjs';

export type PageConfig = {
  hideNavBar?: boolean;
  hideHeader?: boolean;
  hideFooter?: boolean;
  theme?: ThemeType;
};

/**
 * Hook to access page configuration from AngularJS route configuration.
 * Listens to $routeChangeSuccess events to update when route changes.
 *
 * @returns {PageConfig} Page configuration object with hideNavBar, hideHeader, and theme properties
 *
 * @example
 * // In route config:
 * $routeProvider.when('/some-route', {
 *   pageConfig: { hideNavBar: true, theme: 'dark' }
 * });
 */
export const usePageConfig = (): PageConfig => {
  const getPageConfig = (): PageConfig => {
    const $route = getService('$route');
    return $route?.current?.pageConfig || {};
  };

  const [pageConfig, setPageConfig] = useState<PageConfig>(getPageConfig);

  const updatePageConfig = () => {
    const newPageConfig = getPageConfig();

    setPageConfig(newPageConfig);
  };

  useLayoutEffect(() => {
    const $rootScope = getService('$rootScope');

    const unsubscribeRouteUpdate = $rootScope.$on(
      '$routeChangeSuccess',
      updatePageConfig,
    );

    return () => {
      unsubscribeRouteUpdate();
    };
  }, []);

  return pageConfig;
};
